import React from 'react';

export type BtnVariant = 'primary' | 'orange' | 'outline' | 'ghost' | 'danger' | 'outline-white' | 'white';

interface BtnProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: BtnVariant;
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

const variantClasses: Record<BtnVariant, string> = {
  primary:
    'bg-gradient-primary text-white shadow-btn hover:opacity-90 active:opacity-80',
  orange:
    'bg-gradient-orange text-white shadow-btn-orange hover:opacity-90 active:opacity-80',
  outline:
    'border-2 border-brand-blue text-brand-blue bg-transparent hover:bg-brand-blue/5 active:bg-brand-blue/10',
  ghost:
    'bg-[rgba(4,101,216,0.08)] text-brand-blue hover:bg-[rgba(4,101,216,0.14)] active:bg-[rgba(4,101,216,0.20)]',
  danger:
    'bg-semantic-danger text-white hover:opacity-90 active:opacity-80',
  'outline-white':
    'border-2 border-white text-white bg-transparent hover:bg-white/10 active:bg-white/20',
  white:
    'bg-white text-brand-blue hover:bg-white/90 active:bg-white/80 shadow-none',
};

const sizeClasses: Record<'sm' | 'md' | 'lg', string> = {
  sm:  'h-9  px-4 text-[14px] font-[700] rounded-btn',
  md:  'h-[52px] px-6 text-[17px] font-[800] rounded-btn',
  lg:  'h-14 px-8 text-[18px] font-[800] rounded-btn',
};

export function Btn({
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  icon,
  children,
  className = '',
  disabled,
  ...rest
}: BtnProps) {
  return (
    <button
      disabled={disabled}
      className={[
        'inline-flex items-center justify-center gap-2 transition-all duration-200 font-nunito',
        sizeClasses[size],
        variantClasses[variant],
        fullWidth ? 'w-full' : '',
        disabled ? 'opacity-50 cursor-not-allowed pointer-events-none' : 'cursor-pointer',
        className,
      ].join(' ')}
      {...rest}
    >
      {icon && <span className="flex-shrink-0">{icon}</span>}
      {children}
    </button>
  );
}
